
import { useLocation, Link } from "react-router-dom";
import { Liferay } from "../../common/services/liferay/liferay";

interface CongratulationsProps {
  mensaje: string;
  labelButton: string;
  header: string;
  to: string;
}

const Congratulations: React.FC<CongratulationsProps> = ({mensaje, labelButton, header, to}) => {
  const location = useLocation();
  const payload = location.state?.payload;
  const isSignedIn = Liferay.ThemeDisplay.isSignedIn();


  const MaskGroupImage = "/documents/d/guest/Mask-group_1";
  const AssetImage1_500w = "/documents/d/guest/44471622448-1-p-500";
  const AssetImage2_500w = "/documents/d/guest/image-p-500";
  const Circle = "/documents/d/guest/marque-el-circulo-15-1";

  return (
    <>
      <section className="hero relative">
        <div className="padding-global z-index">
          <div className="padding-section-large">
            <div className="container-medium">
              <div className="hero_wrp is-mig">
                <div className="hero_box">
                  <div className="title-component">
                    <h1 className="title">¡Hola, {payload.names ? payload.names: payload.Names}!</h1>
                    <div className="line-title"></div>
                  </div>
                  <div>{header}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="banner_bg is-ajuste">
          <img
            loading="lazy"
            src={MaskGroupImage}
            alt=""
            className="banner_person-full is-medium movil"
          />
          <img
            sizes="(max-width: 479px) 100vw, (max-width: 767px) 320px, (max-width: 991px) 28vw, 572.25px"
            srcSet={`${AssetImage1_500w} 500w, /documents/d/guest/44471622448-1 585w`}
            alt=""
            src="/documents/d/guest/44471622448-1"
            loading="lazy"
            className="banner_person-full is-medium desp"
          />
          <img
            sizes="(max-width: 991px) 100vw, 613.921875px"
            srcSet={`${AssetImage2_500w} 500w, /documents/d/guest/image 785w`}
            alt=""
            src="/documents/d/guest/image"
            loading="lazy"
            className="banner_person-full medium is-ajuste desp"
          />
        </div>
      </section>
      <section className="perfil">
        <div className="padding-global">
          <div className="padding-section-medium">
            <div className="container-medium">
              <div className="info_wrp is-left">
                <img
                  src={Circle}
                  loading="lazy"
                  alt=""
                  className="banner_flex-icom"
                />
                <div className="text-regular-body">
                  {mensaje}                  
                </div>
                <a href={isSignedIn ? to : "/"} className="button is-large is-perfil w-button">
                  {labelButton}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Congratulations;
